export enum BookOwnership {
  ASSIGNMENT_GRP = 'ASSIGNMENT_GRP', // 서평단(필사단)
  RENTAL = 'RENTAL', // 대여
  GIFTED = 'GIFTED', // 선물받은책
  PURCHASED = 'PURCHASED', // 구매한책
  ETC = 'ETC' // 기타
}

export enum BookStatus {
  PLAN_TO_READ = 'PLAN_TO_READ', // 읽을책
  READING = 'READING', // 읽는중
  DONE_TO_READ = 'DONE_TO_READ' // 읽은책
}

export enum ScriptStatus {
  PLAN_TO_SCRIPT = 'PLAN_TO_SCRIPT', // 필사할책
  SCRIPTING = 'SCRIPTING', // 필사중
  DONE_TO_SCRIPT = 'DONE_TO_SCRIPT' // 필사한책
}

export enum RecordType {
	READING = 'READING', //독서 
	SCRIPTING = 'SCRIPTING' //필사  
}



export enum BookRegType {
  NUBOOK = 'NUBOOK', // 누북
  MOIM = 'MOIM', // 모임
  RECRUIT = 'RECRUIT', // 모집
}

export enum AcceptMethod {
	ADMIN_APPROVAL = 'ADMIN_APPROVAL', //관리자 승인
	FIRST_COME_FIRST_SERVED = 'FIRST_COME_FIRST_SERVED', //선착순
	AUTO_APPROVAL = 'AUTO_APPROVAL' //자동 승인	
}


export enum BookEventType {

	RECRUIT_REVIEWER = 'RECRUIT_REVIEWER', //서평단 
	RECRUIT_SCRIPTER = 'RECRUIT_SCRIPTER', //필사단  
	ETC = 'ETC' //기타 
}

export enum ApplicantStatus {
	APPLY = 'APPLY', //신청  
	ACCEPTED = 'ACCEPTED', // 수락  
	REJECTED = 'REJECTED', // 거절 
	CANCEL = 'CANCEL' //신청취소   
}


export enum CommunityApplicantStatus {
	APPLIED = 'APPLIED', //신청
	APPROVED = 'APPROVED', //승인
	REJECTED = 'REJECTED', //탈락
	CANCELLED = 'CANCELLED', //신청취소
	WITHDRAWN = 'WITHDRAWN', //탈퇴
}


export enum CommunityBoardType {
	DEFAULT = 'DEFAULT', //자유게시판
	ETC = 'ETC', //기타
}

export enum CommunityType {
	ONLINE = 'ONLINE', //온라인
	OFFLINE = 'OFFLINE', //오프라인
}


export enum ActivityType {
	
	BOOK_REVIEW = 'BOOK_REVIEW', //서평
	BOOK_SCRIPT = 'BOOK_SCRIPT', //필사
	ETC = 'ETC' //기타
}


export enum NbmessageType {
	DRMSG = 'DRMSG', //"Direct Message"),
	INQRY = 'INQRY', //"문의"),
	BANNER_INQRY = 'BANNER_INQRY', //"배너 문의"),
	PARTNERSHIP_INQRY = 'PARTNERSHIP_INQRY' //"파트너십 문의")	
}

export function nbmessageType2text(nbmessageType: NbmessageType): string {

  switch (nbmessageType) {
    case NbmessageType.DRMSG:
      return 'Direct Message';
    case NbmessageType.INQRY:
      return '문의';
    default:
      return '';
  }
}

export function activityType2text(activityType: ActivityType): string {
  switch (activityType) {
    case ActivityType.BOOK_REVIEW:
      return '독서';
    case ActivityType.BOOK_SCRIPT:
      return '필사';
    case ActivityType.ETC:
      return '기타';
    default:
      return '';
  }
}

export function communityType2text(communityType: CommunityType): string {

  switch (communityType) {
    case CommunityType.ONLINE:
      return '온라인';
    case CommunityType.OFFLINE:
      return '오프라인';
    default:
      return '';
  }
}

export function communityBoardType2text(communityBoardType: CommunityBoardType): string {
  switch (communityBoardType) {
    case CommunityBoardType.DEFAULT:
      return '자유게시판';
    case CommunityBoardType.ETC:
      return '기타';
    default:
      return '';
  }
}


export function communityApplicantStatus2text(communityApplicantStatus: CommunityApplicantStatus): string {
  switch (communityApplicantStatus) {
    case CommunityApplicantStatus.APPLIED:
      return '신청';
    case CommunityApplicantStatus.APPROVED:
      return '승인';
    case CommunityApplicantStatus.REJECTED:
      return '탈락';
    case CommunityApplicantStatus.CANCELLED:
      return '신청취소';
    case CommunityApplicantStatus.WITHDRAWN:
      return '탈퇴';
    default:
      return '';
  }
}

export enum MeetingType {
	ONLINE = 'ONLINE', //온라인
	OFFLINE = 'OFFLINE', //오프라인
}

export enum NoobookRole {

	ADMIN = 'ADMIN',
	 PROFESSIONAL = 'PROFESSIONAL', //프로형  
	 LEADER = 'LEADER', //리더형  
	 COMMUNITY = 'COMMUNITY', //참여형  
	 PERSONAL = 'PERSONAL', //개인형 
	 FREEUSER = 'FREEUSER' //무료회원
}



export enum BannerType {
	MAIN = 'MAIN',
	SUB_1 = 'SUB_1',
	SUB_2 = 'SUB_2',
	SUB_3 = 'SUB_3',
}


export function bannerType2text(bannerType: BannerType): string {
  switch (bannerType) {
    case BannerType.MAIN:
      return '메인';
    case BannerType.SUB_1:
      return '서브_1';
    case BannerType.SUB_2:
      return '서브_2';
  }
  return '';
}


export function noobookRole2text(noobookRole: NoobookRole): string {
  //console.log(noobookRole);
  switch (noobookRole) {
    case NoobookRole.ADMIN:
      case 'ADMIN':
      return '관리자';
    case NoobookRole.PROFESSIONAL:
      case 'PROFESSIONAL':
      return '프로형';
    case NoobookRole.LEADER:
      case 'LEADER':
      return '리더형';
    case NoobookRole.COMMUNITY:
      case 'COMMUNITY':
      return '참여형';
    case NoobookRole.PERSONAL:
      case 'PERSONAL':
      return '개인형';
    case NoobookRole.FREEUSER:
      case 'FREEUSER':
      return '무료회원';
    default:
      return '';
  }
}


export function applicantStatus2text(applicantStatus: ApplicantStatus): string {
  switch (applicantStatus) {
    case ApplicantStatus.APPLY:
      return '신청';
    case ApplicantStatus.ACCEPTED:
      return '수락';
    case ApplicantStatus.REJECTED:
      return '거절';
    case ApplicantStatus.CANCEL:
      return '신청취소';
    default:
      return '';
  }
}

export function bookEventType2text(bookEventType: BookEventType): string {
  switch (bookEventType) {
    case BookEventType.RECRUIT_REVIEWER:
      return '서평단 모집';
    case BookEventType.RECRUIT_SCRIPTER:
      return '필사단 모집';
    case BookEventType.ETC:
      return '기타';
    default:
      return '';
  }
}

export function acceptMethod2text(acceptMethod: AcceptMethod): string {
  switch (acceptMethod) {
    case AcceptMethod.ADMIN_APPROVAL:
      return '관리자 승인 후 참여';
    case AcceptMethod.FIRST_COME_FIRST_SERVED:
      return '선착순 마감';
    case AcceptMethod.AUTO_APPROVAL:
      return '신청 후 자동 승인';
    default:
      return '';
  }
}


export function ownership2text(ownership: BookOwnership): string {
  switch (ownership) {
    case BookOwnership.ASSIGNMENT_GRP:
      return '서평단(필사단)';
    case BookOwnership.RENTAL:
      return '대여';
    case BookOwnership.GIFTED:
      return '선물받은책';
    case BookOwnership.PURCHASED:
      return '구매한책';
    case BookOwnership.ETC:
      return '기타';
    default:
      return '';
  }
}

export function bookStatus2text(bookStatus: BookStatus): string {
  switch (bookStatus) {
    case BookStatus.PLAN_TO_READ:
      return '읽을책';
    case BookStatus.READING:
      return '읽는중';
    case BookStatus.DONE_TO_READ:
      return '읽은책';
    default:
      return '';
  }
}

export function scriptStatus2text(scriptStatus: ScriptStatus): string {
  switch (scriptStatus) {
    case ScriptStatus.PLAN_TO_SCRIPT:
      return '필사할책';
    case ScriptStatus.SCRIPTING:
      return '필사중';
    case ScriptStatus.DONE_TO_SCRIPT:
      return '필사한책';
    default:
      return '';
  }
}

export function bookRegType2Path(bookRegType: BookRegType): string {
  switch (bookRegType) {
    case BookRegType.NUBOOK:
      return '/book-register';
    case BookRegType.MOIM:
      return '/booklist-register';
    case BookRegType.RECRUIT:
      return '/moim-recruit';
    default:
      return '/book-register';
  }
}



